export const sampleData = {
	listing: {
		address: '123 American Drive',
		address1: '',
		city: 'Anytowne',
		state: 'DC',
		zip: '12345',
		country: 'USA',
		status: 'Active',
		list_price: 499900,
		beds: 3,
		baths: 2,
		acreage: 0.5,
		sq_foot: 2123,
		description:
			'Timeless and tasteful, this stunning 2123 sqft home sits on a 1/2 acre behind guarded gates in a single-story residential neighborhood.',
		virtual_tour: '',
		video_tour: '',
		image_data: [
			'https://staging-bay.cdn.bkat.io/services/design/sampleData/listing-001.jpg',
			'https://staging-bay.cdn.bkat.io/services/design/sampleData/listing-002.jpg',
			'https://staging-bay.cdn.bkat.io/services/design/sampleData/listing-003.jpg',
		],
		disclaimer:
			'This information is deemed reliable, but not guaranteed. All information should be independently verified.',
	},
	user: {
		active: true,
		birthDate: '04/30/1972',
		city: 'Anytowne',
		country: 'USA',
		postalCode: '12345',
		stateProvince: 'DC',
		streetAddress: '123 Anywhere St',
		websiteUrl: 'https://www.somecoolcompany.com',
		email: 'someuser@somecompany.com',
		firstName: 'Some',
		fullName: 'Some User',
		imageUrl:
			'https://staging-bay.cdn.bkat.io/services/design/sampleData/agent.jpg',
		lastName: 'User',
		middleName: '',
		mobilePhone: '7025551212',
		primaryPhone: '7025551212',
		displayPhone: '7025550123',
		tenantId: '',
		timezone: 'America/Los_Angeles',
		id: '123456789',
		parent_account_id: '1382',
		brandPrimaryColor: '#000000',
		brandSecondaryColor: '#EB4034',
		logoDarkUrl:
			'https://staging-bay.cdn.bkat.io/services/design/sampleData/logo-dark.jpg',
		logoLightUrl:
			'https://staging-bay.cdn.bkat.io/services/design/sampleData/logo-light.png',
		licenseNumber: 'AB123456',
		title: 'SUPER COOL AGENT',
		certifications: 'GRI, CRS',
		companyName: 'Super Cool Company',
	},
	altos: {
		mean_dom: 45,
		mean_per_sqft: 250,
		count: 150,
		max_price: 750000,
		dom_median: 42,
		median_price: 485000,
		price_median: 485000,
		median_price_of_new_listings: 495000,
		per_sqft_median: 245,
		min_price: 285000,
	},
};
